<template>
	<section class="query_ticket_wrap">
		<div class="inquire_wrap">
			<div class="depart" @click="showGetOnList">
				<i class="iconfont icon-location2 primaryColor-text"></i>
				<span>出发站点 :</span>
				<span class="select_departure">{{ GetOn == '' ? '请选择上车地点' : GetOn }}</span>
			</div>
			<div class="departure_day" @click="showSetDatePicker">
				<i class="iconfont icon-riqixuanze gray-text"></i>
				<span>选择出发日期 :</span>
				<span class="datePicker">{{ SetDate }}</span>
			</div>
			<div class="destination" @click="showGetOffList">
				<i class="iconfont icon-location2 red-text"></i>
				<span>选择需要到达地点 :</span>
				<span class="select_airport site_name_w">{{ GetOff == '' ? '请选择站点' : GetOff }}</span>
			</div>
		</div>

		<description-mask :tipsType="tipsType"></description-mask>

		<div class="btn_wrap big-btn"><button class="btn inquire_btn" @click="getBusList">查询船次</button></div>
	</section>
</template>

<script>
import frequencyApi from '../../request/frequencyApi';
import baseTool from '../../utils/baseFunction';
import DescriptionMask from './DescriptionMask';
import { mapState } from 'vuex';

export default {
	name: 'BoatTicketCondition',
	data() {
		return {
			setDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'),
			getOn: '',
			getOff: '',
			getOnList: [],
			getOffList: [],
			getOnIndex: 0,
			getOffIndex: 0,
			tipsType: 'buyBoatTicket',
			businessId: 2
		};
	},
	components: {
		DescriptionMask
	},
	mounted() {
		this.getGetOnList();
		this.getGetOffList();
	},
	methods: {
		getBusList() {
			// this.$store.commit('boat/setBaseBoatCondition', this.setDate, this.getOn, this.getOff);
			this.$router.push({
				name: 'ChooseFrequencyList',
				params: {
					mode: 1
				}
			});
		},
		getGetOnList() {
			let that = this;
			frequencyApi.getGetOnList(2, 1).then(sucRes => {
				console.log(sucRes);
				this.getOnList = sucRes.data;
				if (this.getOnList.length > 0) {
					that.$store.commit('boat/setBaseBoatCondition', { GetOn: that.getOnList[0].PlaceName });
				}
			});
		},
		getGetOffList() {
			let that = this;
			frequencyApi.getGetOffList(2, 1).then(sucRes => {
				this.getOffList = sucRes.data;
				if (this.getOffList.length > 0) {
					that.$store.commit('boat/setBaseBoatCondition', { GetOff: that.getOffList[0].PlaceName });
				}
			});
		},
		showGetOnList() {
			let that = this;
			let tmpArray = new Array();
			for (let i = 0; i < this.getOnList.length; i++) {
				let tmp = {
					label: this.getOnList[i].PlaceName,
					value: this.getOnList[i].PlaceName
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.$store.commit('boat/setBaseBoatCondition', { GetOn: result[0].value });
				}
			});
		},
		showGetOffList() {
			let that = this;
			let tmpArray = new Array();
			for (let i = 0; i < this.getOffList.length; i++) {
				let tmp = {
					label: this.getOffList[i].PlaceName,
					value: this.getOffList[i].PlaceName
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.$store.commit('boat/setBaseBoatCondition', { GetOff: result[0].value });
				}
			});
		},
		getDate(type) {
			const date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();

			if (type === 'start') {
				year = year - 60;
			} else if (type === 'end') {
				year = year + 2;
			}
			month = month > 9 ? month : '0' + month;
			day = day > 9 ? day : '0' + day;
			return `${year}-${month}-${day}`;
		},
		showSetDatePicker() {
			let that = this;
			this.$weui.datePicker({
				start: new Date(), // 从今天开始
				end: baseTool.addDate(new Date(), 60),
				onConfirm: function(result) {
					var tmpDate = result[0].value + '-' + result[1].value + '-' + result[2].value;
					// that.setDate = result[0].value + '-' + result[1].value + '-' + result[2].value;
					that.$store.commit('boat/setBaseBoatCondition', { SetDate: tmpDate });
				}
			});
		}
	},
	computed: mapState({
		startDate() {
			return this.getDate('start');
		},
		endDate() {
			return this.getDate('end');
		},
		SetDate: state => state.boat.SetDate,
		GetOn: state => state.boat.GetOn,
		GetOff: state => state.boat.GetOff
	})
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/child-components/BoatTicketCondition.vue